function janrainSignOut(){
			janrain.capture.ui.endCaptureSession();
}
(function() {
		if (typeof window.janrain !== 'object') window.janrain = {};
		window.janrain.settings = {};
		window.janrain.settings.capture = {};

		// capture settings
		janrain.settings.capture.language = 'en-US';
		janrain.settings.capture.redirectUri = 'https://beta.toneitup.com/wp-admin/admin-ajax.php?action=janrain_capture_redirect_uri';
		janrain.settings.capture.appId= 'brncy9vhvastkepmatghd5t9zq';
		janrain.settings.capture.clientId = 'tcazb5sqnhfmqfqxvstqjbrw6ehqdgav';
		janrain.settings.capture.responseType = 'code';
		janrain.settings.capture.captureServer = 'https://toneitup-dev.us-dev.janraincapture.com';
		janrain.settings.capture.registerFlow = 'socialRegistration';
		janrain.settings.packages = ['capture','login'];

		janrain.settings.capture.setProfileCookie = true;
		janrain.settings.capture.keepProfileCookieAfterLogout = true;
		janrain.settings.capture.setProfileData = true;

		// styles
		janrain.settings.capture.stylesheets = ['https://beta.toneitup.com/wp-content/plugins/janrain-capture-screens/stylesheets/demo.css','https://beta.toneitup.com/wp-content/plugins/janrain-capture-screens/stylesheets/janrain.css','https://beta.toneitup.com/wp-content/plugins/janrain-capture-screens/stylesheets/janrain-mobile.css',];
janrain.settings.capture.recaptchaPublicKey = '6LeVKb4SAAAAAGv-hg5i6gtiOV4XrLuCDsJOnYoP'; //captcha			// engage settings
			janrain.settings.language = 'en-US';
			janrain.settings.appUrl = 'https://toneitup-dev.rpxnow.com/';
			janrain.settings.tokenAction = 'event';
			
			// mobile-specific settings
			janrain.settings.tokenAction = 'url';
			janrain.settings.popup = false;
			janrain.settings.tokenUrl = janrain.settings.capture.captureServer;
			janrain.settings.capture.redirectFlow = true;
			janrain.settings.capture.redirectUri = 'https://beta.toneitup.com/';
		function isReady() { janrain.ready = true; };
		if (document.addEventListener) {
				document.addEventListener("DOMContentLoaded", isReady, false);
		} else {
				window.attachEvent('onload', isReady);
		}

		var e = document.createElement('script');
		e.type = 'text/javascript';
		e.id = 'janrainAuthWidget'
		var url = document.location.protocol === 'https:' ? 'https://' : 'http://';
		url += 'widget-cdn.rpxnow.com/load/toneitup-dev';
		e.src = url;
		var s = document.getElementsByTagName('script')[0];
		s.parentNode.insertBefore(e, s);
})();
		
janrain.settings.capture.flowName = 'standard';
janrain.settings.capture.flowVersion = 'HEAD';

function hideLoginScreen() {
    jQuery("#SignInOverlay").hide();
    jQuery("body").removeClass("modal-open");
};

// call our code/token exchanger, and use the token to set up a capture session
function getTokenForCode(code, redirect_uri) {
	var url = '/wp-admin/admin-ajax.php?action=janrain_capture_redirect_uri&redirect=' + encodeURIComponent(janrain.settings.capture.redirectUri);
	url += "&code=" + code;
	window.location.href = url;
}

function janrainReturnExperience() {
	var span = document.getElementById('traditionalWelcomeName');
	var name = janrain.capture.ui.getReturnExperienceData("displayName");
	if (span && name) {
		span.innerHTML = "Welcome back, " + name + "!";
	}
}
function getParameterByName(name) {
        name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
            results = regex.exec(location.search);
        return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}
function janrainCaptureWidgetOnLoad() {



      //make sure the document is loaded before starting




    //check for access token in localStorage and create session
    if(localStorage && localStorage.getItem("janrainCaptureTokenWP")) {
        janrain.capture.ui.createCaptureSession(localStorage.getItem("janrainCaptureTokenWP"));
        localStorage.removeItem("janrainCaptureTokenWP");
    }



    function handleCaptureLogin(result) {
        // console.log ("exchanging code for token...");
        getTokenForCode(result.authorizationCode, janrain.settings.capture.redirectUri);
    }

    function handleNoScreen(result) {

        window.onetimecode = result.authorizationCode;
    }

    janrain.events.onCaptureSessionFound.addHandler(function(result){
	     console.log ("capture session found");
    });
    janrain.events.onCaptureSessionNotFound.addHandler(function(result){
	    // console.log ("capture session not found");
    });


	janrain.events.onCaptureAccessDenied.addHandler(function(result){
		janrain.capture.ui.createCaptureSession(access_token);
	});

  janrain.events.onCaptureRenderComplete.addHandler(function(result){
            if (result.screen == "emailNotVerified") {
                janrain.capture.ui.endCaptureSession();
            }
        });
        
	janrain.events.onCaptureScreenShow.addHandler(function(result){
		if (result.screen == "returnTraditional") {
			janrainReturnExperience();
		}
        if (result.screen == "socialRegistration") {
            janrain.capture.ui.modal.open();
            $("#SignInOverlay").show();
            $("body").addClass("modal-open");
        }
        jQuery(".site_login_btn").click(function(){
           janrain.capture.ui.modal.open();
           jQuery("#SignInOverlay").show();
        });


        if(getParameterByName("screenToRender") !== "" || getParameterByName("code") !== "") {
             janrain.capture.ui.modal.open();
             jQuery("#SignInOverlay").show();
        }
	});

for(var i=0; i<janrain.events.captureEvents.length; i++) {
    var handler = janrain.events.captureEvents[i];
    var fhandler = (function(e) {
        return function(result){console.log("Fired:" + e); console.log(result);};
    })(handler)
    janrain.events[handler].addHandler(fhandler);
  }
    janrain.events.onCaptureLoginFailed.addHandler(function(e){
        if(e.statusMessage == "accountDeactivated") {
          jQuery(".capture_processing").hide();
          jQuery(".capture_primary").show();
          jQuery("#deactivated-janrain").show();
        }
    });
    janrain.events.onCaptureLoginSuccess.addHandler(handleCaptureLogin);
    janrain.events.onCaptureRegistrationSuccess.addHandler(handleCaptureLogin);

    janrain.events.onCaptureSaveSuccess.addHandler(handleNoScreen);

    janrain.events.onCaptureProfileSaveSuccess.addHandler(function(result){
        //console.log("NoLoginHit 3");
        //console.log(result);
        if(typeof window.onetimecode !== "undefined")
          getTokenForCode(window.onetimecode, janrain.settings.capture.redirectUri);

    });


    janrain.settings.capture.screenToRender = getParameterByName('screenToRender');
    if(getParameterByName('code') !== "")
    {
      janrain.settings.capture.screenToRender = "resetPasswordRequestCode";
    }

    janrain.capture.ui.start();



}